export interface SalesOrderPurchaseAllocation {
  id: string;
  purchaseOrderLineId: string;
  salesOrderLineId: string;
  purchaseOrderAndLineNo: string;
  supplierKey: string;
  supplierName: string;
  productKey: string;
  productDescription: string;
  productType: string;
  balance: number;
  allocated: number;
  totalAllocated: number;
  freeStock: number;
  qtyRequired: number;
  selected: boolean;
  canDelete: boolean;
  deliveryDate: Date;
  nearestEighth: boolean;
  orderStatus: string;
}
